import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from '../../CheckoutForm';

const StripeComponent = ({
  stripePromise,
  payment,
  onPaymentSuccess,
  setOrder,
  setPayment,
  totalPrice,
  onCancelPayment,
  elementsOptions,
}) => {
  return (
    <Elements stripe={stripePromise} options={elementsOptions}>
      <CheckoutForm
        payment={payment}
        onSuccess={onPaymentSuccess}
        setOrder={setOrder}
        totalPrice={totalPrice}
        setPayment={setPayment}
        onCancel={onCancelPayment}
      />
    </Elements>
  );
};

export default StripeComponent;
